import { type InvoiceDate, type InvoiceReviewStatus } from '@vy/types';
import { vyDate } from '@vy/utils';

const month = vyDate().month();
const year = vyDate().year();

export const DEFAULT_INVOICES_TABLE_SELECTED_MONTHS: InvoiceDate[] = [{ month: month.toString(), year }];

export const DEFAULT_INVOICES_TABLE_SELECTED_ROWS = [];

export const DEFAULT_INVOICES_TABLE_SELECTED_BILLING_STATUSES = [];

export const DEFAULT_INVOICES_TABLE_SELECTED_WORKFLOW: InvoiceReviewStatus[] = [];
